<ion-content aria-label="PRIVACY NOTICE">
  <div #headerRef>
    <div class="header"><ion-icon (click)="dismiss()" name="close-circle-outline"></ion-icon></div>

    <div class="container">
      <div class="toggle-container">
        <button (click)="showPrivaceNotice(1)" color="primary" class="toggle-button privacy-button"
          [ngClass]="{'active': privacyPolicyType === 1}">{{crbConfigName}} PRIVACY NOTICE</button>
        <button (click)="showPrivaceNotice(2)" color="primary" class="toggle-button privacy-button"
          [ngClass]="{'active': privacyPolicyType === 2}">CRB PRIVACY NOTICE</button>
        <button (click)="showPrivaceNotice(3)" color="primary" class="toggle-button privacy-button"
          *ngIf="marketingPartnerPrivacyNotice" [ngClass]="{'active': privacyPolicyType === 3}">{{ programName }}
          PRIVACY
          NOTICE</button>
      </div>
    </div>
  </div>

  <iframe *ngIf="this.safeResourceUrl" [src]="safeResourceUrl" class="dynamic-content"></iframe>
</ion-content>